"use strict";
/*
 * Created on 11 12 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * FamilyBindingConverter
 *
 * @author JMe
 */


var FamilyBindingConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(FamilyBindingConverter, _DataObjectConverter_);

  function FamilyBindingConverter() {
    _classCallCheck(this, FamilyBindingConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(FamilyBindingConverter).apply(this, arguments));
  }

  return FamilyBindingConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.FamilyBindingConverter = FamilyBindingConverter;